<template>
  <validation-observer ref="simpleRules">
    <b-form>

      <!-- Score Name -->
      <b-form-group
        label="Score Name"
        label-for="mc-score-name"
      >
        <validation-provider
          #default="{ errors }"
          name="Score Name"
          rules="required"
        >
          <b-form-input
            v-model="item.scoreName"
            :state="errors.length > 0 ? false:null"
            placeholder="Score Name"
          />
          <small class="text-danger">{{ $t(errors[0]) }}</small>
        </validation-provider>
      </b-form-group>

      <!-- Formula -->
      <b-form-group
        label="Formula"
        label-for="mc-formula"
      >
        <validation-provider
          #default="{ errors }"
          name="Formula"
          rules="required"
        >
          <b-form-textarea
            v-model="item.formula"
            :state="errors.length > 0 ? false:null"
            placeholder="Formula"
          />
          <small class="text-danger">{{ $t(errors[0]) }}</small>
        </validation-provider>
      </b-form-group>

      <!-- Group Level -->
      <b-form-group
        label="Level"
        label-for="groupLevel"
      >
        <validation-provider
          #default="{ errors }"
          name="Group Level"
          rules="required|between:0,999"
        >
          <b-form-input
            v-model="item.groupLevel"
            :state="errors.length > 0 ? false:null"
            placeholder="Group Level (0-999)"
          />
          <small class="text-danger">{{ $t(errors[0]) }}</small>
        </validation-provider>
      </b-form-group>

      <!-- Group Order -->
      <b-form-group
        label="Order"
        label-for="groupOrder"
      >
        <validation-provider
          #default="{ errors }"
          name="Group Order"
          rules="required|between:0,999"
        >
          <b-form-input
            v-model="item.groupOrder"
            :state="errors.length > 0 ? false:null"
            placeholder="Group Order (0-999)"
          />
          <small class="text-danger">{{ $t(errors[0]) }}</small>
        </validation-provider>
      </b-form-group>

    </b-form>
  </validation-observer>
</template>

<script>
import useJwt from '@/auth/jwt/useJwt'

import {
  BFormGroup, BFormInput, BForm, BFormTextarea,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BFormGroup,
    BFormInput,
    BForm,
    BFormTextarea,
  },
  props: {
    projectId: {
      type: [Number, String],
      required: true,
    },
    value: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      defaultItem: {
        scoreName: null,
        formula: null,
        basedOnFrequency: false,
      },
      required,
    }
  },
  computed: {
    item: {
      set(value) {
        this.$emit('input', value)
      },
      get() {
        if (this.value) {
          return this.value
        }
        return this.defaultItem
      },
    },
  },
  created() {
    this.item.projectId = this.projectId
  },
  methods: {
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          if (this.item.id) {
            useJwt.axiosIns.patch('scoredefinition/virtual', this.item)
              .then(response => {
                if (response.data) {
                  this.$emit('submit')
                }
              })
              .catch(e => {
                console.log(e)
              })
          } else {
            useJwt.axiosIns.post('scoredefinition/virtual', this.item)
              .then(response => {
                if (response.data) {
                  this.$emit('submit')
                }
              })
              .catch(e => {
                console.log(e)
              })
          }
        }
      })
    },
  },
}
</script>
